/**
 * Ultimas3DetalhadoReport - N144 (Alana)
 *
 * Mesmo comparativo do Ultimas3ContagensReport, mas com a linha aberta por
 * produto+lote: e o unico grao em que Lote e Validade existem (no agregado eles
 * morrem no Sum() do job inteiro). Sem a coluna "Colet": quantidade_coletar e
 * decisao de coleta do job, nao do lote.
 */
import React from 'react';
import { RelatorioGeraisTable, type Column } from './RelatorioGeraisTable';

const metricas = (prefix: string, group: string): Column[] => [
  { key: `${prefix}_sistema`, label: 'Sistema', align: 'right', format: 'decimal', width: '80px', group },
  { key: `${prefix}_contado`, label: 'Contado', align: 'right', format: 'decimal', width: '80px', group },
  { key: `${prefix}_falta`, label: 'Falta', align: 'right', format: 'decimal', width: '70px', group },
  { key: `${prefix}_sobra`, label: 'Sobra', align: 'right', format: 'decimal', width: '70px', group },
];

const columns: Column[] = [
  { key: 'cliente_nome', label: 'Cliente', width: '180px', group: 'Cliente' },
  { key: 'hospital_nome', label: 'Hospital', width: '200px', group: 'Hospital' },
  { key: 'hospital_codigo', label: 'Cód.', align: 'center', width: '110px', group: 'Hospital' },
  { key: 'codigo_produto', label: 'Produto', width: '120px', group: 'Item' },
  { key: 'descricao', label: 'Descrição', width: '220px', group: 'Item' },
  { key: 'lote', label: 'Lote', width: '110px', group: 'Item' },
  { key: 'data_validade', label: 'Validade', align: 'center', format: 'date', width: '100px', group: 'Item' },
  ...metricas('ult', 'ÚLTIMA'),
  ...metricas('pen', 'PENÚLTIMA'),
  ...metricas('ant', 'ANTEPENÚLTIMA'),
];

function flattenContagem(c: any, prefix: string): Record<string, any> {
  if (!c) return {
    [`${prefix}_sistema`]: null,
    [`${prefix}_contado`]: null,
    [`${prefix}_falta`]: null,
    [`${prefix}_sobra`]: null,
  };
  return {
    [`${prefix}_sistema`]: c.total_sistema,
    [`${prefix}_contado`]: c.total_contado,
    [`${prefix}_falta`]: c.total_falta,
    [`${prefix}_sobra`]: c.total_sobra,
  };
}

interface Props {
  data: any[];
  loading?: boolean;
  totalRecords?: number;
  currentPage?: number;
  totalPages?: number;
  onPageChange?: (page: number) => void;
}

export const Ultimas3DetalhadoReport: React.FC<Props> = ({
  data,
  loading,
  totalRecords,
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const transformedData = data.map(row => ({
    cliente_nome: row.cliente_nome,
    hospital_nome: row.hospital_nome,
    hospital_codigo: row.hospital_codigo,
    codigo_produto: row.codigo_produto,
    descricao: row.descricao,
    lote: row.lote,
    data_validade: row.data_validade,
    ...flattenContagem(row.ultima, 'ult'),
    ...flattenContagem(row.penultima, 'pen'),
    ...flattenContagem(row.antepenultima, 'ant'),
  }));

  return (
    <RelatorioGeraisTable
      columns={columns}
      data={transformedData}
      loading={loading}
      showTotals={true}
      emptyMessage="Nenhum item encontrado nas contagens executadas do período."
      totalRecords={totalRecords}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
    />
  );
};
